module.exports = __webpack_public_path__ + "static/img/bg_down_top.d4d3dc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/download/bg_down_top.png
// module id = VLEl
// module chunks = 23